var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8359 9.66927H10.8359V4.66927C10.8359 4.20844 10.4626 3.83594 10.0026 3.83594C9.5426 3.83594 9.16927 4.20844 9.16927 4.66927V9.66927H4.16927C3.70927 9.66927 3.33594 10.0418 3.33594 10.5026C3.33594 10.9634 3.70927 11.3359 4.16927 11.3359H9.16927V16.3359C9.16927 16.7968 9.5426 17.1693 10.0026 17.1693C10.4626 17.1693 10.8359 16.7968 10.8359 16.3359V11.3359H15.8359C16.2959 11.3359 16.6693 10.9634 16.6693 10.5026C16.6693 10.0418 16.2959 9.66927 15.8359 9.66927Z",
    fill: "#5DA196"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_14976",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8359 9.66927H10.8359V4.66927C10.8359 4.20844 10.4626 3.83594 10.0026 3.83594C9.5426 3.83594 9.16927 4.20844 9.16927 4.66927V9.66927H4.16927C3.70927 9.66927 3.33594 10.0418 3.33594 10.5026C3.33594 10.9634 3.70927 11.3359 4.16927 11.3359H9.16927V16.3359C9.16927 16.7968 9.5426 17.1693 10.0026 17.1693C10.4626 17.1693 10.8359 16.7968 10.8359 16.3359V11.3359H15.8359C16.2959 11.3359 16.6693 10.9634 16.6693 10.5026C16.6693 10.0418 16.2959 9.66927 15.8359 9.66927Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_14976)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#5DA196"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus20);
export default __webpack_public_path__ + "static/media/plus20.d94de360c33fc0184aebddc71c408dd6.svg";
export { ForwardRef as ReactComponent };